
<div mat-dialog-title>
	<span class="share-view-title" translate>customer.share.view</span>
	<button mat-icon-button class="exit-button-icon" [disableRipple]="true" (click)="closeDialog()" type="button">
		<mat-icon svgIcon="md:close"></mat-icon>
	</button>
</div>
<div mat-dialog-content>
	<div class="share-view-block-right-margin">
		<mat-form-field class="input-max-width">
			<mat-label translate>datacenter.view-name</mat-label>
			<input matInput [formControl]="viewName" [(ngModel)]="shareViewName"/>
			<mat-error *ngIf="viewName.invalid" translate>view.validation</mat-error>
		</mat-form-field>
	</div>

	<div class="share-view-block-right-margin">
		<mat-form-field class="input-max-width">
			<mat-chip-grid #chipList>
				<mat-chip-row
					*ngFor="let user of selectedUsers"
					[editable]="true"
					(removed)="remove(user)"
					highlighted="true"
					color="accent"
					>
					{{ user }}
					<mat-icon matChipRemove svgIcon="md:close"></mat-icon>
				</mat-chip-row>
				<input
					#userInput
					[formControl]="suggestiveControl"
					[matAutocomplete]="auto"
					[matChipInputFor]="chipList"
					[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
					(matChipInputTokenEnd)="onChangeUser($event)"
					[placeholder]="'organization.card.users' | translate"
				>
			</mat-chip-grid>
			<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectUser($event)">
				<mat-option disabled class="copo-mat-option-is-loading" *ngIf="isLoading">
					<copo-loading-spinner></copo-loading-spinner>
				</mat-option>
				<ng-container *ngIf="!isLoading">
					<mat-option *ngFor="let filteredUser of filteredUsers" [value]="filteredUser">
						{{ filteredUser['firstName'] }} {{ filteredUser['lastName'] }}
					</mat-option>
				</ng-container>
			</mat-autocomplete>
			<mat-error *ngIf="validateUsers()" translate>user.validation</mat-error>
		</mat-form-field>
	</div>
</div>
<div mat-dialog-actions>
	<button cdkFocusInitial class="share-view-button" type="submit" mat-button [mat-dialog-close]="shareViewName"
	(click)="shareViewWithUsers()" [disabled]="viewName.invalid || validateUsers()">
		<span class="share-view-button-name" translate>share.view.share</span>
		<mat-icon iconPositionEnd class="share-view-button-icon" svgIcon="share"></mat-icon>
	</button>
</div>
